import { StepperAssignmentURLSteps } from '~app/shared/enums/stepper-assignment-urls-steps.constant';
import { IStepperProcessSteps } from '../interfaces/process-step.interface';

export const CHECKOUT_STEPS: IStepperProcessSteps = {
  [StepperAssignmentURLSteps.POLICIES]: {
    progress: {
      isCrewMember: 50,
      isContractor: 50,
    },
    redirections: {
      next: StepperAssignmentURLSteps.PERSONAL_CONTACT,
      previous: StepperAssignmentURLSteps.IDLE,
    },
  },
  [StepperAssignmentURLSteps.PERSONAL_CONTACT]: {
    progress: {
      isCrewMember: 100,
      isContractor: 100,
    },
    redirections: {
      next: StepperAssignmentURLSteps.IDLE,
      previous: StepperAssignmentURLSteps.POLICIES,
    },
  },
};
